/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ValidationError } from '../model/validation-error.model';
import { MessageFactory, MessageFactoryProvider } from '../provider/message-factory.provider';
import { TextService } from '../service/text.service';

export class ValidationErrorMessageFactory implements MessageFactory {

  constructor(private textService: TextService) { }

  getMessage(error: ValidationError): string {
    const keyMessageFactory = MessageFactoryProvider.resolveMessageFactory(error.validationKey);
    if (keyMessageFactory) {
      return keyMessageFactory.getMessage(error);
    }
    const textKey = error.validationKey;
    const textArgs = error.validationArguments;
    return this.textService.getText(textKey, textArgs);
  }

}
